// Keep the complete server response intact; each UI view uses only the user's
// selected factor source, including legacy reviews and grouped proposals.
export function selectFactorVendorReviews({ reviews = [], groups = [] }, selectedFactorVendor) {
    const vendor = String(selectedFactorVendor || '').trim().toLowerCase();
    const matches = (review) => vendor && String(review.provider || '').trim().toLowerCase() === vendor;
    return {
        reviews: reviews.filter(matches),
        groups: groups.map((group) => ({
            ...group,
            proposals: (group.proposals || []).filter(matches),
        })).filter((group) => group.proposals.length),
    };
}
